import "./PublishButton.less";

import { Button, Checkbox, Modal } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import * as React from "react";

import { IBaseProps } from "lib/data/interfaces";

import { AuthorizedComponent } from "components/general";


interface IPublishButtonProps extends IBaseProps {
	tooltip?: string;
	actionText?: string;
	isLoading?: boolean;
	isDisabled?: boolean;
	onPublish?: (isCascadePublish: boolean) => void;
	onCancel?: () => void;
}

interface IPublishButtonState {
	showModal: boolean;
	isCascade: boolean;
}


export class PublishButton extends React.Component<IPublishButtonProps, IPublishButtonState> {

	constructor(props: IPublishButtonProps) {

		super(props);

		this.state = {
			showModal: false,
			isCascade: false
		};
	}

	public render() {

		return (
			<AuthorizedComponent>
				<div className="publish-button-wrapper">
					<Button
						loading={this.props.isLoading}
						disabled={this.props.isDisabled}
						onClick={this.onButtonClick}
						type="default"
						className="publish-button"
						shape="circle"
						icon="book"
						size="small"
					/>

					{this.props.actionText ? <div className="ant-button-action-text">{this.props.actionText}</div> : ""}

					<Modal
						visible={this.state.showModal}
						onCancel={this.onCancel}
						onOk={this.onPublish}
						footer={[
							<Button key="Cancel" onClick={this.onCancel}>
								Cancel
							</Button>,
							<Button key="publish" type="primary" onClick={this.onPublish}>
								Publish
							</Button>,
						]}
						className="publish-confirm-modal"
					>
						<div>
							<p>Publishing is instant and all users will immediately be able to view your changes. Are you sure you want to continue?</p>

							<Checkbox checked={this.state.isCascade} onChange={this.onCheckboxChange}>Publish all child drafts?</Checkbox>
						</div>
					</Modal>
				</div>
			</AuthorizedComponent>
		);
	}

	private onButtonClick = () => {

		this.setState({ showModal: true });
	}

	private onCheckboxChange = (e: CheckboxChangeEvent) => {

		// Set Cascade To Value Of Checkbox
		this.setState({ isCascade: e.target.checked });
	}

	private onCancel = () => {

		if (this.props.onCancel) {

			this.props.onCancel();
		}

		this.setState({ showModal: false, isCascade: false });
	}

	private onPublish = () => {

		if (this.props.onPublish) {

			this.props.onPublish(this.state.isCascade);
		}

		this.setState({ showModal: false, isCascade: false });
	}
}
